import React from "react";

import { Box, HStack, Icon, Text } from "@chakra-ui/react";

import { usePropertyModalTheme } from "./usePropertyModalTheme";

export default function PropertyModalSection({ icon, title, headerExtra, children }) {
	const { borderColor, iconColor } = usePropertyModalTheme();

	return (
		<Box border="1px" borderColor={borderColor} borderRadius="lg" p={4}>
			<HStack spacing={2} justifyContent="space-between" mb={3} pb={2} borderBottom="1px" borderColor={borderColor}>
				<HStack spacing={2}>
					{icon && <Icon as={icon} color={iconColor} boxSize={4} />}
					<Text fontWeight="semibold" fontSize="sm">
						{title}
					</Text>
				</HStack>
				{headerExtra}
			</HStack>
			{children}
		</Box>
	);
}
